import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import IacManagementResourceCell from "../components/ResourceCell";
import { RenderResourceRowCellProps } from ".";

const IacManagementTableResourceRowCellResourcesCount = memo(
  (props: RenderResourceRowCellProps) => {
    return (
      <IacManagementResourceCell {...props}>
        <TableCellEmpty />
      </IacManagementResourceCell>
    );
  }
);

IacManagementTableResourceRowCellResourcesCount.displayName =
  "IacManagementTableResourceRowCellResourcesCount";

export default IacManagementTableResourceRowCellResourcesCount;
